(function () {
    "use strict";

    angular.module("app").directive("stretchPane", StretchPaneDirectiveFactory);

    StretchPaneDirectiveFactory.$inject = ["$window", "$document"];
    function StretchPaneDirectiveFactory($window, $document) {
        return {
            restrict: "A",
            link: function (_scope, element) {

                // Settings
                const spaceBelowPane = 15;
                const hiddenClassSelector = ".end-reached";

                // DOM elements needed for the calculations
                const scrollPane = element[0];
                const elementAbove = scrollPane.previousElementSibling;
                const elementBelow = scrollPane.nextElementSibling;

                scrollPane.style.overflow = "auto";
                scrollPane.style.width = "100%";

                if (!elementAbove || !elementBelow) {
                    return;
                }

                // Attach events

                $window.addEventListener("resize", resizePane, true);

                // An accordion is collapsed or expanded somewhere on the page
                $document.on("hidden.bs.collapse", resizePane);
                $document.on("shown.bs.collapse", resizePane);

                // Watch for changes inside the panel
                const scrollPaneObserver = new MutationObserver(resizePane);
                scrollPaneObserver.observe(scrollPane, {
                    childList: true,
                    subtree: true,
                });

                // Because the infiniteScrollIndicator directive does not use ng-class, the MutationObserver is not triggered after the transition ends.
                // For the existing indicators the resizing works by accident because angularjs adds intermediate animation classes
                if (elementBelow.tagName === "INFINITE-SCROLL-INDICATOR") {
                    elementBelow.addEventListener("transitionend", resizePane);
                }
                else {

                    const nextSiblingObserver = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (mutation.attributeName === 'class') {
                                resizePane();
                            }
                        });
                    });
                    nextSiblingObserver.observe(elementBelow, { attributes: true });

                }

                function resizePane() {
                    const scrollPaneHeadersBottom = elementAbove.getBoundingClientRect().bottom;
                    const scrollIndicatorY = elementBelow.getBoundingClientRect().y;
                    const scrollPaneHeight = (scrollIndicatorY - scrollPaneHeadersBottom) - spaceBelowPane;
                    scrollPane.style.height = scrollPaneHeight + "px";

                    forceOverflowY();
                }

                function forceOverflowY() {

                    // If no content is present we wait until items are added
                    if (!scrollPane.lastElementChild)
                        return;

                    // When all items have been loaded, the scroll indicator get a class to hide it
                    const isComplete = $document[0].querySelector(hiddenClassSelector) !== null;

                    // Calculate the height difference between the pane's contents and the viewport together with a padding
                    const missingSpace = scrollPane.getBoundingClientRect().bottom - scrollPane.lastElementChild.getBoundingClientRect().bottom + 15;

                    // WHEN not all items are present (more can be loaded)
                    // AND we do not fill the viewport + 15px yet
                    // THEN add a small amount of padding on the bottom
                    if (!isComplete && missingSpace >= 0)
                        scrollPane.style.paddingBottom = missingSpace + "px";
                    else
                        delete scrollPane.style.paddingBottom;
                }
            }
        };
    }
})();
